export default  {
    OVER_TIME: 1,
    AS_INCURRED: 2
}